import SimpleLightbox from 'simple-lightbox';

class Lightbox {
  constructor() {
    this._setup();
  }

  _setup() {
    new SimpleLightbox({
      elements: 'li.list-media__item a'
    });
  }
}

export default Lightbox;
